$(function () {

    $('#insiders-login-form').on('shown.bs.modal', function () {

        // Detect if the remember me checkbox input is present and auto check it, as it is hidden and should always be on
        if ($('#rememberme').length) document.getElementById("rememberme").checked = true;

        // Submit GA event Insiders - showing-login-dialog
        window.helpers.gaEvent('Insiders', 'showing-login-dialog', '');
        window.helpers.gaEvent('Account Users', 'login-dialog-shown', '');

        if ($('#property-listings-container').length) {
            // var newUrl = window.location.href;
            // if(window.helpers.includes(newUrl, '?')) {
            //     newUrl = newUrl + '&login_complete=true';
            // } else {
            //     newUrl = newUrl + '?login_complete=true';
            // }
            let newUrl = window.location.origin + '/profile?return_url=' + encodeURIComponent(window.location.href);
            $('#loginform input[name=redirect_to]').val(newUrl);
        }

    });

    $('#insiders-register-form').on('shown.bs.modal', function () {

        if ($('#registration-action-url').length) {
            $('#insiders-registration-form-object').attr('action', $('#registration-action-url').val());
            $('#registration_check_value').val('hallhall2018registrationFormCheck');
        }

        $('html, body').addClass('locked-for-modal');

        if ($('#property-listings-container').length) {
            $('#insiders-registration-form-object').attr('action', window.location.href);
        }

        window.helpers.gaEvent('Insiders', 'showing-register-dialog', '');
        window.helpers.gaEvent('Account Users', 'register-dialog-shown', '');
    });

    $('#insiders-register-form').on('hidden.bs.modal', function () {
        $('html, body').removeClass('locked-for-modal');
    });

    $('#loginform').on('submit', function () {
        window.helpers.gaEvent('Insiders', 'user-logged-in', '');
        window.helpers.gaEvent('Account Users', 'login-complete', '');
    });

    if ($('#registration-success').length) {
        window.helpers.gaEvent('Insiders', 'user-has-registered', '');
        window.helpers.gaEvent('Account Users', 'register-completed', 'new-registrants');
    }

    let propertyIdParameter = '';
    if ($('#property-detail-property-id').length) {
        propertyIdParameter = $('#property-detail-property-id').val();
    }

    $('#broker-contact-modal').on('shown.bs.modal', function () {
        window.helpers.gaEvent('Submissions:Property-detail', 'broker-contact-opened', propertyIdParameter);
    });

    $('#broker-contact-form').on('submit', function () {
        window.helpers.gaEvent('Submissions:Property-detail', 'broker-contact-submitted', propertyIdParameter);
        window.helpers.gaEvent('Form Submission', 'broker-contact', propertyIdParameter);
    });

    $('#broker-contact-modal-2').on('shown.bs.modal', function () {
        window.helpers.gaEvent('Submissions:Property-detail', 'broker-contact-opened', propertyIdParameter);
    });

    $('#broker-contact-form-2').on('submit', function () {
        window.helpers.gaEvent('Submissions:Property-detail', 'broker-contact-submitted', propertyIdParameter);
        window.helpers.gaEvent('Form Submission', 'broker-contact', propertyIdParameter);
    });

    $('#gform_2').on('submit', function () {
        window.helpers.gaEvent('Submissions:General-inquiry', 'general-contact-submitted', '');
        window.helpers.gaEvent('Form Submission', 'contact', '');
    });

    $('.broker-call-link-ga').on('click', function () {
        window.helpers.gaEvent('Call:Property-detail', 'call-link-clicked', propertyIdParameter);
        window.helpers.gaEvent('Phone', 'property-detail', propertyIdParameter);
    });

    $('.header-call-link').on('click', function () {
        window.helpers.gaEvent('Call:Header', 'call-link-clicked', '');
        window.helpers.gaEvent('Phone', 'header', '');
    });

    $('.header-email-link').on('click', function () {
        window.helpers.gaEvent('Email:Header', 'email-link-clicked', '');
        window.helpers.gaEvent('Email', 'header', '');
    });

    $('.footer-call-link').on('click', function () {
        window.helpers.gaEvent('Call:Footer', 'call-link-clicked', '');
        window.helpers.gaEvent('Phone', 'footer', '');
    });

    $('.footer-email-link').on('click', function () {
        window.helpers.gaEvent('Email:Footer', 'email-link-clicked', '');
        window.helpers.gaEvent('Email', 'footer', '');
    });

    if ($('#contact-content').length) {
        $('a.contact-email-to-link').on('click', function (e) {

            let email = $(this).attr('href').replace('mailto:', ''),
                label = $(this).data('label');

            window.helpers.gaEvent('Email:Contact', 'email-link-clicked', email);
            window.helpers.gaEvent('Email', 'contact', label);

        });

        $('a.contact-call-link').on('click', function () {
            let label = $(this).data('label');

            window.helpers.gaEvent('Phone', 'contact', label);
        });
    }

// TODO: In progress, add in a viewing of each property
// if($('.property-item').length && !$('#property-listings').length) {
//     setTimeout(function () {
//         $('.property-item').each(function () {
//              window.helpers.gaEvent('Property', 'shown-in-thumbnail', $(this).data('property-id'));
//         });
//     }, 2000);
// }

});
